/**
 * Feature types for Map
 */

const featureTypes = {
    localidad: 'localidad',
    track: 'track',
    albergue: 'albergue',
    poi: 'poi',
    route: 'route',
} as const;

/** Tipo de feature tal y como viene en las capas del tileset. */
type FeatureType = typeof featureTypes[keyof typeof featureTypes];

/**
 * Data types for URL query string and REST URL
 */
const dataTypes = {
  route: 'route', // Camino
  stage: 'stage', // Etapa
  hotel: 'hotel', // Accommodation
  place: 'place', // City, monument, etc...
  track: 'track', // Generic track (route, stage)
  page: 'page',   // Page with text content.
  poi: 'poi',   // POI info point.
} as const;

/** Tipo de dato en la query string y en las URL del REST. */
type DataType = typeof dataTypes[keyof typeof dataTypes];

/**
 * Classes for different data types
 */
const dataClass = {
  hotel: 'accommodation',
  poi: 'poi',
} as const;

/**
 * States for geoPermission service status.
 */
const geoPermStatus = {
  granted: 'granted',
  prompt: 'prompt',
  denied: 'denied',
} as const;

/** Estado del permiso de geolocalizacion. */
type GeoPermStatus = typeof geoPermStatus[keyof typeof geoPermStatus];

/**
 * Conversion: data type to feature type
 *
 * El parametro es string y no DataType a proposito: la conversion se usa sobre
 * tipos que llegan del REST y de la URL sin validar, y el default es quien los
 * rechaza.
 */
const dataTypeToFeatureType = function(type: string): FeatureType {
  switch (type) {
    case dataTypes.place:
      return featureTypes.localidad;
    case dataTypes.hotel:
      return featureTypes.albergue;
    case dataTypes.poi:
      return featureTypes.poi;
    default:
      throw new Error("Cannot convert data type: " + type);
  }
}

/**
 * Conversion: feature type to data type
 *
 * @see dataTypeToFeatureType
 */
const featureTypeToDataType = function(type: string): DataType {
  switch (type) {
    case featureTypes.localidad:
      return dataTypes.place;
    case featureTypes.albergue:
      return dataTypes.hotel;
    case featureTypes.poi:
      return dataTypes.poi;
    default:
      throw new Error("Cannot convert feature type: " + type);
  }
}

export {
    featureTypes,
    dataTypes,
    dataClass,
    geoPermStatus,
    dataTypeToFeatureType,
    featureTypeToDataType,
};

export type {
    FeatureType,
    DataType,
    GeoPermStatus,
};
